// helpers/vectorIdentifier

export default function vectorIdentifier(filename) {

  return filename.match(/\.(ai|eps|epi|eps2|eps3|epsf|epsi|ept|pdf|svg)$/ig) ? true : false

}